import { Component } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
// import { NavigationEnd, Router } from "@angular/router";
import { UpdateMessage } from "src/app/_services/snackbar.service";
import { StorageService } from "src/app/_services/storage.service";
import Dexie from "dexie";

@Component({
  selector: "app-toast",
  templateUrl: "./toast.component.html",
  styleUrls: ["./toast.component.scss"],
})
export class ToastComponent {
  errorMessage: Array<{ message: string; type: string; time: number }> = [];
  message: Array<Array<string>> = [];
  constructor(
    private messageService: UpdateMessage,
    private router: Router,
    private _storageService: StorageService
  ) {
    // creating error toast messages
    this.messageService.currentError.subscribe(
      (errorMsg: { message: string; type: string }) => {
        if (errorMsg && errorMsg.message != "") {
          if (errorMsg.message.includes("401")) {
            this.logoutUser();
          } else {
            this.errorMessage.push({ ...errorMsg, time: Date.now() });
          }
        }
      }
    );

    // creating api toast messages
    this.messageService.currentMessage.subscribe((message) => {
      if (message[0] != "") {
        this.message.push(message);
      }
    });

    // closing  api toast messages
    this.messageService.currentClose.subscribe((message) => {
      this.message = this.message.filter(
        (item: Array<string>) => item[0] !== message
      );
    });
    // closing all toast in route change
    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.errorMessage = [];
        this.message = [];
      }
    });
  }
  ngOnInit() {
    this.removeErrorMessages();
  }

  removeErrorMessages() {
    // to remove error messages after 3 seconds
    setTimeout(() => {
      var time = Date.now();
      this.errorMessage = this.errorMessage.filter(function (item) {
        return time < item.time + 3000 || item.type == "http";
        // error mesages from http requests should not be removed
      });
    }, 500);
  }

  logoutUser() {
    this._storageService.delete_cookie("auth-user");
    this._storageService.delete_cookie("PMS_GWT");
    this._storageService.delete_cookie("auth-token");
    this._storageService.delete_cookie("auth-identifier");
    this._storageService.delete_cookie("user_stamp");
    this.retainFavsInLocalStorge();
    window.location.href = window.origin;
    Dexie.delete("PMSDB");
  }

  retainFavsInLocalStorge() {
    const allKeys = Object.keys(localStorage);
    allKeys.forEach((key) => {
      if (key !== "favLinks") {
        localStorage.removeItem(key);
      }
    });
  }
}
